import { useState, useEffect } from 'react';
import { LoadTransactionsUseCase } from '../../application/useCases';
import { TransactionApiData } from '../../shared/types';

export const useTransactions = (supplierId: number | null, token: string | null) => {
    const [transactions, setTransactions] = useState<TransactionApiData[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const loadTransactions = async () => {
        if (!supplierId || !token) {
            setTransactions([]);
            return;
        }

        try {
            setIsLoading(true);
            const useCase = new LoadTransactionsUseCase();
            const result = await useCase.execute(supplierId, token);
            setTransactions(result);
        } catch (error) {
            console.error('Error loading transactions:', error);
            setTransactions([]);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadTransactions();
    }, [supplierId, token]);

    return {
        transactions,
        isLoading,
        reload: loadTransactions,
    };
};

